import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

/* -------------------------
   STRING FIELD
-------------------------- */
export const StringField = ({
  label,
  id,
  value,
  onChange,
  placeholder,
  required = false,
  error,
  type = "text",
}) => (
  <div className="space-y-2">
    {label && <Label htmlFor={id}>{label}</Label>}
    <Input
      id={id}
      type={type}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      required={required}
      className="w-full"
    />
    {error && <p className="text-sm text-red-500">{error}</p>}
  </div>
);

/* -------------------------
   TEXTAREA FIELD
-------------------------- */
export const TextareaField = ({
  label,
  id,
  value,
  onChange,
  placeholder,
  rows = 3,
  required = false,
  error,
}) => (
  <div className="space-y-2">
    {label && <Label htmlFor={id}>{label}</Label>}
    <Textarea
      id={id}
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      required={required}
      className="w-full"
    />
    {error && <p className="text-sm text-red-500">{error}</p>}
  </div>
);
